import { Component, OnInit, Input } from '@angular/core'
import { DatePipe } from '@angular/common'
import { License } from '../../models/license-details'
import { LicenseStatus } from '../../models/license-status'
import { LicenseApptGateway } from '../../gateways/license-appt-gateway'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { LicenseDataService } from '../../gateways/license-data-service'
import * as moment from 'moment'
import { AppointmentStatus } from '../../models/appointment-status'
import { Router, ActivatedRoute, Params } from '@angular/router'
import { UserDataService } from '../../gateways/user-data-service'
import { PortalGlobals } from '../../../portalglobals'
import { ContentManagementDetail } from '../../../content-management/models/content-mgt-detail'
import { OrgSettingsModel } from '../../../common/models/org-settings-model'
@Component({
    selector: 'Licenseafterlogin',
    templateUrl: 'license-login.component.html'
})
export class LicenseLoginComponent implements OnInit {
    currentUser: CurrentUser
    @Input()
    licenseViewModel: License[] = []
    licensedataModel: License
    licenseInsertModel: License
    licenseEditModel: License
    licensedeleteModel: License
    @Input() superGuruAdmin = false
    orgAdminMngr = false
    saveRow = false
    showConfirmDelete = false
    LicenseStatusId: number
    index: number | null
    allStates: any[]
    allLicenseStatus: LicenseStatus[]
    licenseStatus: LicenseStatus | undefined
    allAppointmentStatus: AppointmentStatus[]
    appointStatus: AppointmentStatus | undefined
    displayMessage: String
    updateLicense: Boolean
    savedMessage: String
    showMessage: Boolean
    UserProfileID: number
    licExpMessageAvailable: boolean
    licExpMessage: string | null
    showDefaultMessage: boolean
    showAppt: boolean
    loading: boolean = true

    constructor(
        private currentUserGateway: CurrentUserGateway,
        private licenseApptGateway: LicenseApptGateway,
        private licenseDataService: LicenseDataService,
        private route: ActivatedRoute,
        private routers: Router,
        private userdataservice: UserDataService,
        private _global: PortalGlobals
    ) {
        this.currentUser = {} as CurrentUser
        this.licenseViewModel = {} as License[]
        this.licenseInsertModel = {} as License
        this.licenseEditModel = {} as License
        this.licensedataModel = {} as License
        this.licensedeleteModel = {} as License
    }

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.UserProfileID = params['userprofileid']
        })
        this.loading = true
        this.licenseApptGateway.getExpireLicense(this.UserProfileID).subscribe((model: License[]) => {
            this.licenseViewModel = model
            if (this.licenseViewModel.length == null || this.licenseViewModel.length == 0) {
                this.loading = false
                this.userdataservice.changeMessage(true)
                localStorage.setItem('showlicense', 'false')
                if (
                    (this._global.currentUser.roleCode === 'Call Center Representative' ||
                        this._global.currentUser.roleCode === 'Call Center Agent') &&
                    this._global.currentUser.insuranceCompanyName !== this._global.insuranceCompanyNameNEJE
                ) {
                    if (this._global.currentUser.active)
                        this.routers.navigateByUrl(this._global.currentUser.insuranceCompanyShortName.toLowerCase() + '/callStart/verifyVdn')
                    else this.routers.navigateByUrl(this._global.currentUser.insuranceCompanyShortName.toLowerCase() + '/home')
                } else {
                    this.routers.navigateByUrl(this._global.currentUser.insuranceCompanyShortName.toLowerCase() + '/home')
                }

                this.setData()
            } else {
                this.licenseApptGateway.getContentDetails('LICEXPMSG', 'LICEXPSECTION').subscribe((data: ContentManagementDetail[]) => {
                    this.loading = false
                    if (data === null || data === undefined) {
                        this.licExpMessageAvailable = false
                        this.showDefaultMessage = true
                    } else {
                        if (data.length > 0) {
                            this.licExpMessageAvailable = true
                            this.licExpMessage = data[0].TextContent
                        } else {
                            this.licExpMessageAvailable = false
                            this.showDefaultMessage = true
                        }
                    }
                    this.setData()
                })
            }
        })
    }

    setData() {
        this.getAllAppointment()

        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        if (
            this._global.currentUser !== undefined &&
            this._global.currentUser !== null &&
            this._global.currentUser.userProfileName !== undefined &&
            this._global.currentUser.userProfileName !== null &&
            this._global.currentUser.userProfileName !== ''
        ) {
            if (this._global.currentUser.IsGuruAdmin === true || this._global.currentUser.IsSuperAdminAdmin === true) {
                this.superGuruAdmin = !this.superGuruAdmin
                if (this.licenseViewModel.length > 0) {
                    this.licenseViewModel.forEach((licenses) => {
                        if (licenses.LicenseStatusId === 3) {
                            if (
                                licenses.AppointmentStatusName === 'Inactive' ||
                                licenses.AppointmentStatusName === 'Terminated' ||
                                licenses.AppointmentStatusName === null
                            ) {
                                licenses.appoint = true
                            } else if (licenses.AppointmentStatusName === 'Pending') {
                                licenses.cfmappoint = true
                            } else if (licenses.AppointmentStatusName === 'Active') {
                                licenses.terminate = true
                            } else if (licenses.AppointmentStatusName === 'TerminationPending') {
                                licenses.cfmterminate = true
                            }
                        } else {
                            licenses.appoint = false
                            licenses.cfmappoint = false
                            licenses.cfmterminate = false
                            licenses.terminate = false
                        }
                    })
                }
            } else if (this._global.currentUser.isOrganizationalAdmin || this._global.currentUser.isOrganizationalManager) {
                this.orgAdminMngr = !this.orgAdminMngr
            }
        } else {
            this.currentUserGateway.getCurrentUser().subscribe((model: CurrentUser) => {
                this.currentUser = model
                if (this.currentUser != null) {
                    this.licenseApptGateway.getFMOSettings(model.insuranceCompanyId).subscribe((data: OrgSettingsModel[]) => {
                        this.loading = false
                        let res = data.find((x) => x.SettingName.toUpperCase() === 'SHOW APPOINTMENT')
                        if (res === undefined || res === null) {
                            this.showAppt = false
                        } else {
                            if (res.SettingValue.toUpperCase() === 'YES') {
                                this.showAppt = true
                            } else {
                                this.showAppt = false
                            }
                        }
                    })
                    if (this.currentUser.IsGuruAdmin === true || this.currentUser.IsSuperAdminAdmin === true) {
                        this.loading = false
                        this.superGuruAdmin = !this.superGuruAdmin
                        if (this.licenseViewModel.length > 0) {
                            this.licenseViewModel.forEach((licenses) => {
                                if (licenses.LicenseStatusId === 3) {
                                    if (
                                        licenses.AppointmentStatusName === 'Inactive' ||
                                        licenses.AppointmentStatusName === 'Terminated' ||
                                        licenses.AppointmentStatusName === null
                                    ) {
                                        licenses.appoint = true
                                    } else if (licenses.AppointmentStatusName === 'Pending') {
                                        licenses.cfmappoint = true
                                    } else if (licenses.AppointmentStatusName === 'Active') {
                                        licenses.terminate = true
                                    } else if (licenses.AppointmentStatusName === 'TerminationPending') {
                                        licenses.cfmterminate = true
                                    }
                                } else {
                                    licenses.appoint = false
                                    licenses.cfmappoint = false
                                    licenses.cfmterminate = false
                                    licenses.terminate = false
                                }
                            })
                        }
                    } else if (this._global.currentUser.isOrganizationalAdmin || this._global.currentUser.isOrganizationalManager) {
                        this.loading = false
                        this.orgAdminMngr = !this.orgAdminMngr
                    }
                }
            })
        }

        this.index = null
        this.showMessage = false

        if (this.UserProfileID === null || this.UserProfileID === undefined) {
            this.route.params.forEach((params: Params) => {
                if (params['userprofileid']) {
                    this.UserProfileID = params['userprofileid']
                }
            })
        }
    }

    editLicense(licenseID: number, index: number, LicenseNumber: number, license: License) {
        license.EditRow = true
        this.index = index
        this.getAllLicenseStatus()
    }

    saveRowLicense(license: License, index: number) {
        license.EditRow = false
        this.index = index

        this.licenseEditModel.LicenseID = license.LicenseID
        this.licenseEditModel.LicenseNumber = license.LicenseNumber
        this.licenseEditModel.LicenseExpirationDate = moment(license.LicenseExpirationDate).toDate()
        this.licenseStatus = this.allLicenseStatus.find((x) => x.LicenseStatus === license.Status)
        this.licenseEditModel.LicenseStatusId = this.licenseStatus?.LicenseStatusID || 0
        this.licenseEditModel.UserProfileID = license.UserProfileID

        this.licenseApptGateway.editLicense(this.licenseEditModel).subscribe((model: License[]) => {
            this.licenseApptGateway.getExpireLicense(this.UserProfileID).subscribe((model: License[]) => {
                this.licenseViewModel = model
            })
            if (this.licenseViewModel.length > 0) {
                this.getAppointmentButtons()
                this.licenseViewModel.forEach((licenses) => {
                    if (licenses.LicenseExpirationDate !== null) {
                        licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                    }
                    if (licenses.AppointmentExpirationDate !== null) {
                        licenses.ExpirationDate = moment(licenses.AppointmentExpirationDate).format('MM/DD/YYYY').toString()
                    }
                    if (licenses.AppointmentEffectiveDate !== null) {
                        licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                    }
                })
                this.savedMessage = 'License Saved Successfully'
                this.showMessage = true
            }
        })
    }

    deleteLicense(licenseID: number, UserProfileID: number): void {
        this.showConfirmDelete = true
        this.displayMessage = 'Confirm Delete License as of  ' + this.getdate()
        this.updateLicense = false
        this.licensedeleteModel.LicenseID = licenseID
        this.licensedeleteModel.UserProfileID = UserProfileID
        this.showMessage = false
    }

    saveLicense() {
        this.licenseInsertModel.UserProfileID = this.UserProfileID
        if (this.currentUser !== undefined && this.currentUser !== null) this.licenseInsertModel.OrgID = parseInt(this.currentUser.orgId)

        this.licenseApptGateway.saveLicense(this.licenseInsertModel).subscribe((model: License[]) => {
            this.licenseApptGateway.getExpireLicense(this.UserProfileID).subscribe((model: License[]) => {
                this.licenseViewModel = model
            })
            if (this.licenseViewModel.length > 0) {
                this.getAppointmentButtons()
                this.licenseViewModel.forEach((licenses) => {
                    if (licenses.LicenseExpirationDate !== null) {
                        licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                    }
                    if (licenses.AppointmentExpirationDate !== null) {
                        licenses.ExpirationDate = moment(licenses.AppointmentExpirationDate).format('MM/DD/YYYY').toString()
                    }
                    if (licenses.AppointmentEffectiveDate !== null) {
                        licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                    }
                })
                this.savedMessage = 'License Saved Successfully'
                this.showMessage = true
            }
        })

        this.licenseInsertModel.LicenseNumber = ''
        this.licenseInsertModel.LicenseExpirationDate = null
        this.licenseInsertModel.LicenseStatusId = null
        this.licenseInsertModel.StateAbbr = ''

        this.saveRow = !this.saveRow
    }

    addNewRow() {
        this.saveRow = !this.saveRow
        this.getStates(this.UserProfileID)
        this.getAllLicenseStatus()
    }
    deleteLicenseData(): void {
        if (this.licensedeleteModel !== undefined) {
            this.licenseApptGateway
                .deleteLicense(this.licensedeleteModel.LicenseID || 0, this.licensedeleteModel.UserProfileID || 0)
                .subscribe((model: License[]) => {
                    this.licenseApptGateway.getExpireLicense(this.UserProfileID).subscribe((model: License[]) => {
                        this.licenseViewModel = model
                    })
                    if (this.licenseViewModel.length > 0) {
                        this.getAppointmentButtons()
                        this.licenseViewModel.forEach((licenses) => {
                            if (licenses.LicenseExpirationDate !== null) {
                                licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentExpirationDate !== null) {
                                licenses.ExpirationDate = moment(licenses.AppointmentExpirationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentEffectiveDate !== null) {
                                licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                            }
                        })
                        this.showMessage = true
                        this.savedMessage = 'License Deleted Successfully'
                    }
                })
        }

        this.showConfirmDelete = false
    }

    updateLicenseStatus(): void {
        if ((this.showConfirmDelete = true)) {
            if (this.licenseInsertModel.LicenseID === undefined || this.licenseInsertModel.LicenseID === null) {
                this.licenseApptGateway.updateStatusofLicense(this.licensedataModel).subscribe((data: License[]) => {
                    this.licenseApptGateway.getExpireLicense(this.UserProfileID).subscribe((model: License[]) => {
                        this.licenseViewModel = model
                    })
                    if (this.licenseViewModel.length > 0) {
                        this.getAppointmentButtons()
                        this.licenseViewModel.forEach((licenses) => {
                            if (licenses.LicenseExpirationDate !== null) {
                                licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentTerminationDate !== null) {
                                licenses.ExpirationDate = moment(licenses.AppointmentTerminationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentEffectiveDate !== null) {
                                licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                            }
                        })
                    }
                })
            } else {
                this.licenseApptGateway.addAppointment(this.licenseInsertModel).subscribe((data: License[]) => {
                    this.licenseViewModel = data
                    this.licenseApptGateway.getExpireLicense(this.UserProfileID).subscribe((model: License[]) => {
                        this.licenseViewModel = model
                    })
                    if (this.licenseViewModel.length > 0) {
                        this.getAppointmentButtons()
                        this.licenseViewModel.forEach((licenses) => {
                            if (licenses.LicenseExpirationDate !== null) {
                                licenses.LicenseDate = moment(licenses.LicenseExpirationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentTerminationDate !== null) {
                                licenses.ExpirationDate = moment(licenses.AppointmentTerminationDate).format('MM/DD/YYYY').toString()
                            }
                            if (licenses.AppointmentEffectiveDate !== null) {
                                licenses.Effectivedate = moment(licenses.AppointmentEffectiveDate).format('MM/DD/YYYY').toString()
                            }
                        })
                    }
                })
                this.licenseInsertModel.LicenseID = null
                this.licenseInsertModel.UserProfileID = null
                this.licenseInsertModel.AppointmentEffectiveDate = null
                this.licenseInsertModel.AppointmentDataSource = null
                this.licenseInsertModel.AppointmentStatusId = null
            }
        }
        this.showMessage = false
        this.showConfirmDelete = false
    }

    appointLicense(licenseID: number, userProfileID: number, appointmentStatusName: string) {
        if (appointmentStatusName !== null) {
            this.appointStatus = this.allAppointmentStatus.find((x) => x.AppointmentStatusName === 'Pending')
            this.licensedataModel.LicenseID = licenseID
            this.licensedataModel.UserProfileID = userProfileID
            this.licensedataModel.AppointmentEffectiveDate = moment.utc().toDate()
            this.licensedataModel.AppointmentStatusId = this.appointStatus?.AppointmentStatusId || null
            this.licensedataModel.AppointmentTerminationDate = null
            this.licensedataModel.AppointmentDataSource = 'AgentPortal'
            this.licenseDataService.sendData(this.licensedataModel)
        } else {
            this.appointStatus = this.allAppointmentStatus.find((x) => x.AppointmentStatusName === 'Pending')
            this.licenseInsertModel.LicenseID = licenseID
            this.licenseInsertModel.UserProfileID = userProfileID
            this.licenseInsertModel.AppointmentEffectiveDate = moment.utc().toDate()
            this.licenseInsertModel.AppointmentDataSource = 'AgentPortal'
            this.licenseInsertModel.AppointmentStatusId = this.appointStatus?.AppointmentStatusId || null
            this.licenseDataService.sendData(this.licenseInsertModel)
        }
        this.showConfirmDelete = true
        this.updateLicense = true
        this.displayMessage = 'Confirm Your Appoint License as on  ' + this.getdate()
        this.showMessage = false
    }

    confirmappointLicense(licenseID: number, userProfileID: number): void {
        this.appointStatus = this.allAppointmentStatus.find((x) => x.AppointmentStatusName === 'Active')
        this.licensedataModel.LicenseID = licenseID
        this.licensedataModel.UserProfileID = userProfileID
        this.licensedataModel.AppointmentStatusId = this.appointStatus?.AppointmentStatusId || null
        this.licensedataModel.AppointmentTerminationDate = null
        this.licenseDataService.sendData(this.licensedataModel)
        this.showConfirmDelete = true
        this.updateLicense = true
        this.displayMessage = 'Confirm Your Appoint License as on  ' + this.getdate()
        this.showMessage = false
    }

    terminateLicense(licenseID: number, userProfileID: number): void {
        this.appointStatus = this.allAppointmentStatus.find((x) => x.AppointmentStatusName === 'TerminationPending')
        this.licensedataModel.LicenseID = licenseID
        this.licensedataModel.UserProfileID = userProfileID
        this.licensedataModel.AppointmentTerminationDate = moment.utc().toDate()
        this.licensedataModel.AppointmentStatusId = this.appointStatus?.AppointmentStatusId || null
        this.licenseDataService.sendData(this.licensedataModel)
        this.showConfirmDelete = true
        this.updateLicense = true
        this.showMessage = false
        this.displayMessage = 'Confirm Your Terminate License as on  ' + this.getdate()
    }

    cfmterminateLicense(licenseID: number, userProfileID: number): void {
        this.appointStatus = this.allAppointmentStatus.find((x) => x.AppointmentStatusName === 'Terminated')
        this.licensedataModel.LicenseID = licenseID
        this.licensedataModel.UserProfileID = userProfileID
        this.licensedataModel.AppointmentStatusId = this.appointStatus?.AppointmentStatusId || null
        this.licenseDataService.sendData(this.licensedataModel)
        this.showConfirmDelete = true
        this.updateLicense = true
        this.showMessage = false
        this.displayMessage = 'Confirm Your Terminate License as on  ' + this.getdate()
    }

    cancelStatusUpdate() {
        this.showMessage = false
        this.showConfirmDelete = false
    }

    getStates(profileID: number) {
        this.licenseApptGateway.getAllStates(profileID).subscribe((model: any[]) => {
            this.allStates = model
        })
    }

    getAllLicenseStatus() {
        this.licenseApptGateway.getAllLicenseStatus().subscribe((model: LicenseStatus[]) => {
            this.allLicenseStatus = model
        })
    }

    getAllAppointment() {
        this.licenseApptGateway.getAllAppointment().subscribe((model: AppointmentStatus[]) => {
            this.loading = false
            this.allAppointmentStatus = model
        })
    }

    getAppointmentButtons() {
        this.licenseViewModel.forEach((licenses) => {
            if (licenses.LicenseStatusId === 3) {
                if (
                    licenses.AppointmentStatusName === 'Inactive' ||
                    licenses.AppointmentStatusName === 'Terminated' ||
                    licenses.AppointmentStatusName === null
                ) {
                    licenses.appoint = true
                } else if (licenses.AppointmentStatusName === 'Pending') {
                    licenses.cfmappoint = true
                } else if (licenses.AppointmentStatusName === 'Active') {
                    licenses.terminate = true
                } else if (licenses.AppointmentStatusName === 'TerminationPending') {
                    licenses.cfmterminate = true
                }
            } else {
                licenses.appoint = false
                licenses.cfmappoint = false
                licenses.cfmterminate = false
                licenses.terminate = false
            }
        })
    }
    getdate(): string {
        let today = new Date()
        let dt = moment(today)
        let date = dt.format('MM/DD/YYYY').toString()
        return date
    }
    continue() {
        this.userdataservice.changeMessage(true)
        localStorage.setItem('showlicense', 'false')
        if (
            (this._global.currentUser.roleCode === 'Call Center Representative' || this._global.currentUser.roleCode === 'Call Center Agent') &&
            this._global.currentUser.insuranceCompanyName !== this._global.insuranceCompanyNameNEJE
        ) {
            if (this._global.currentUser.insuranceCompanyShortName !== null) {
                this.routers.navigateByUrl('/' + this._global.currentUser.insuranceCompanyShortName.toLowerCase() + '/callStart/verifyVdn')
            } else {
                this.routers.navigateByUrl('/callStart/verifyVdn')
            }
        } else {
            if (this._global.currentUser.insuranceCompanyShortName !== null) {
                this.routers.navigateByUrl('/' + this._global.currentUser.insuranceCompanyShortName.toLowerCase() + '/home')
            } else {
                this.routers.navigateByUrl('/home')
            }
        }
    }
}
